const PlacementTestMapper = {
 
        personalities: "نکات شخصیتی",
        considerations: "ملاحظات آموزشی",
        aim_to_learn: "هدف از یادگیری",
        // recorded_voice: "صدای ضبط شده",
        deadline: "ددلاین‌های زمانی",
        class_type: "نحوه برگزاری کلاس",
        study_amount: "میزان مطالعه در روز",
        description: "توضیحات",
        // estimated_level: "سطح زبان آموز",
        // proficiency: "کیفیت سطح زبان",
        // curriculum: "جدول برنامه ریزی"
      };
      

export default PlacementTestMapper;


